import React, { useEffect, useState } from "react";

const InputTextEmail = ({
    config,
    placeholder,
    value,
    defaultValue,
    type,
    onChange = () => { }
}) => {

    const Input = {
        width: "calc(100% - 4vh)",
        border: "none",
        backgroundColor: "transparent",
        fontSize: "2.5vh",
        padding: "1vh",
        textAlign: "left",
        fontWeight: "bold",
        borderBottom: "2px solid #3C3C3B",
        outline: "none",
        color: "#3C3C3B",
    };

    const Input2 = {
        width: "calc(100% - 4vh)",
        border: "none",
        backgroundColor: "transparent",
        fontSize: "2.5vh",
        padding: "1vh",
        textAlign: "left",
        fontWeight: "bold",
        borderBottom: "3px solid #000000",
        outline: "none",
        color: "#000000",
    };

    const [isFocus, setIsFocus] = useState(false);

    const onFocus = () => {
        setIsFocus(true);
    }

    const onBlur = () => {
        setIsFocus(false);
        var expresionReg= /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;
        if(type === "email"){
            let isValidate = expresionReg.test(defaultValue);
            if(!isValidate){
                config.popupAlert(config?.strings?.error, config?.strings?.errorMail);
            }
        }
    }

    return (
        <input style={isFocus ? Input2 : Input} onBlur={onBlur} onFocus={onFocus}
            onChange={(e) => {
                onChange(e);
            }}
            placeholder={placeholder}
            value={value}
            defaultValue={defaultValue}
            type={type}
        />
    );
};

export default InputTextEmail;